import { create } from 'zustand';
import { DEFAULT_LOCALE } from '../i18n';

export const useLocaleStore = create(set => ({
  locale: DEFAULT_LOCALE,
  setLocale: locale => set({ locale }),
}));

export function changeLocale(languageLocale) {
  useLocaleStore.getState().setLocale(languageLocale);
}
